import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import { CircularProgress } from '@material-ui/core';

import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

import {STRIPE_PUBLIC_KEY, CREDIT_CARD_PROCESSOR} from 'api-config';

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
  StripeProvider,
  Elements,
} from 'react-stripe-elements';


import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { getCreditCardFeeDisplay } from "../../assets/helpers/displayHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';
import GridContainer from "../../components/Grid/GridContainer";

const style = {
  creditCardField: {
    border: "1px solid #eee",
    width: "80%"
  },
  creditCardExplanationText: {
    textAlign: "center",
    color: "#999999"
  }
}

class _CreditCard extends React.Component {
  constructor(props) {
    super(props);
    const chargeCreditCardFee = this.props.chargeCreditCardFee ? this.props.chargeCreditCardFee : false;

    this.state = {
      errorMessage: '',
      creditCardProcessor: CREDIT_CARD_PROCESSOR,
      verifyCardStatus: '',
      showVerifyProgressSpinner: false,
      disableSubmitButton: false,
      chargeCreditCardFee: chargeCreditCardFee,
      creditCardFee: ''
    };
  }

  static getDerivedStateFromProps(nextProps, prevState){
    if ((prevState.chargeCreditCardFee !== nextProps.chargeCreditCardFee && nextProps.chargeCreditCardFee && nextProps.chargeCreditCardFee !== '') ||
      (prevState.creditCardFee !== nextProps.creditCardFee && nextProps.creditCardFee && nextProps.creditCardFee !== '')){
      return { chargeCreditCardFee: nextProps.chargeCreditCardFee,  creditCardFee: nextProps.creditCardFee};
    } else return null;
  }


  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chargeCreditCardFee!==this.props.chargeCreditCardFee || prevProps.creditCardFee!==this.props.creditCardFee){
      //Perform some operation here
      this.setState({
        chargeCreditCardFee: this.props.chargeCreditCardFee,
        creditCardFee: this.props.creditCardFee
      });
    }
  }

  handleChange = ({error}) => {
    if (error) {
      this.setState({errorMessage: error.message});
    }
  };

  handleSubmit = async event => {
    event.preventDefault()
    var tokenId = ''
    this.setState({
      verifyCardStatus: 'validating card...',
      showVerifyProgressSpinner: true,
      disableSubmitButton: true
    })
    const { error, token } = await this.props.stripe.createToken()
    if (error) {
      this.setState({
        verifyCardStatus: error.message,
        showVerifyProgressSpinner: false,
        disableSubmitButton: false
      })
    } else if (token) {
      tokenId = token.id
      if (this.props.saveCardOnSubmit) {
        const creditCardData = {
          userId: this.props.userId,
          txToken: tokenId
        }
        axios.post(`${API_ROOT}/creditCard/`, creditCardData, { headers: getApiHeaders() })
          .then(res => this.handleUpdateCreditCardInformation(res));
      } else {
        this.setState({
          verifyCardStatus: '',
          showVerifyProgressSpinner: false,
          disableSubmitButton: false
        })
      }
    }
    this.props.setToken(tokenId, this.state.creditCardProcessor)

  }

  handleUpdateCreditCardInformation(res) {
    if (res.data === 'success') {
      if (this.props.reloadAfterSubmit) {
        sessionStorage.setItem('bankAccountSet', true);
        window.location = '/'
      } else if (this.props.refreshAction) {
        this.setState({
          verifyCardStatus: res.data,
          showVerifyProgressSpinner: false,
          disableSubmitButton: false
        })
        if (this.props.refreshAction) {
          this.props.refreshAction()
        }
        if (this.props.postUpdateAction) {
          this.props.postUpdateAction('credit card')
        }
      }
    } else {
      this.setState({
        verifyCardStatus: res.data,
        showVerifyProgressSpinner: false,
        disableSubmitButton: false
      })
    }

  }


  render() {
    return (
      <div style={{width: '100%', align: 'center', border: ''}}>
        <GridItem xs={12} sm={7}>
          <label>
            Card number
            <CardNumberElement />
          </label>
          <label>
            Expiration date
            <CardExpiryElement />
          </label>
          <label>
            CVC
            <CardCVCElement />
          </label>
          <Button
            size="sm"
            color="cirrusBlue"
            disabled={this.state.disableSubmitButton}
            round
            onClick={this.handleSubmit}
            style={this.props.showVerifyButton ? {} : { display: 'none' }}
            id={'verifyCardButton'}
            >
            verify card
          </Button>
          <Button
              // className={classes.updateProfileButton}
              onClick={this.handleSubmit}
              round
              color="cirrusBlue"
              disabled={this.state.disableSubmitButton}
              id="updateCreditCardInformationButton"
              style={this.props.showVerifyButton ? { display: 'none' } : {}}
            >
            {this.props.submitButtonText}
          </Button>

          <CircularProgress size={20} style={this.state.showVerifyProgressSpinner ? {} : { display: 'none' }}/>

        </GridItem>
        <GridItem xs={12} sm={7} id={'cardStatus'}>
          {this.state.verifyCardStatus}
        </GridItem>
        <GridItem xs={12} sm={7} id={'fee'} style={this.state.chargeCreditCardFee ? {} : { display: 'none' }}>
          <em>{getCreditCardFeeDisplay(this.state.creditCardFee, 'signup')}</em>
        </GridItem>
      </div>

    )
  }
}

const CardForm = injectStripe(_CreditCard);

export class CardDemo extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      last4: '',
      expMonth: '',
      expYear: '',
      brand: '',
    };
  }
  componentDidMount() {
    this._isMounted = true;
    this.loadCreditCardInfo()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadCreditCardInfo() {
    if (this.props.userId) {
      axios.get(`${API_ROOT}/creditCard/?userId=` + this.props.userId, { headers: getApiHeaders() })
        .then(res => this.handleLoadCreditCardInfo(res));
    }
  }

  handleLoadCreditCardInfo(res) {
    this.setState({
      last4: res.data.last4,
      expMonth: res.data.expMonth,
      expYear: res.data.expYear,
      brand: res.data.brand
    })
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer style={this.state.last4 ? {} : { display: 'none' }} >
          <GridItem  xs={12} sm={12}>
            stored card: <span id={'storedCardNumber'}>XXXX XXXX XXXX {this.state.last4}</span>
          </GridItem>
          <GridItem  xs={12} sm={12}>
            exp. date: <span  id={'storedCardExp'}>{this.state.expMonth}/{this.state.expYear}</span>
          </GridItem>
          <GridItem  xs={12} sm={12}>
            card type: <span id={'storedCardBrand'}>{this.state.brand}</span>
          </GridItem>
        </GridContainer>
        <StripeProvider apiKey={STRIPE_PUBLIC_KEY}>
          <Elements>
            <CardForm
              handleResult={this.props.handleResult}
              setToken={this.props.setToken}
              showVerifyButton={this.props.showVerifyButton}
              saveCardOnSubmit={this.props.saveCardOnSubmit}
              userId={this.props.userId}
              submitButtonText={this.props.submitButtonText}
              chargeCreditCardFee={this.props.chargeCreditCardFee}
              creditCardFee={this.props.creditCardFee}
              reloadAfterSubmit={this.props.reloadAfterSubmit}
              refreshAction={this.loadCreditCardInfo.bind(this)}
              postUpdateAction={this.props.postUpdateAction}
              className={classes.creditCardField}
            />
          </Elements>
        </StripeProvider>
      </div>
    );
  }
}

export default withStyles(style)(CardDemo);